import React, { PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import styles from './RedGradientCard.module.scss';

interface IProps extends PropsWithChildren {
  className?: string;
}

export const RedGradientCard: React.FC<IProps> = ({ children, className }) => {
  return <Box className={clsx(styles.card, className)}>{children}</Box>;
};
